import { toInteger } from 'lodash';
import { createCanvas } from '@/utils/file-kit';
import type { ISize, ITableLayer } from '@/version-types';
import { renderLayerContentToCanvas } from './render-to-canvas';

export const renderLayerToStage = async (
    layer: ITableLayer,
    stageSize: ISize,
): Promise<HTMLCanvasElement | undefined> => {
    const layerImage = await renderLayerContentToCanvas(layer);
    if (!layerImage) return;

    const { width, height, left, top, opacity, rotate } = layer;
    const { width: stageWidth, height: stageHeight } = stageSize;
    const resultWidth = toInteger(width);
    const resultHeight = toInteger(height);
    const centerPoint = {
        x: resultWidth / 2 + left,
        y: resultHeight / 2 + top,
    };
    const drawOffsetPoint = {
        x: -resultWidth / 2,
        y: -resultHeight / 2,
    };

    const { canvas: stageCanvas, ctx: stageCtx } = createCanvas(stageWidth, stageHeight);

    stageCtx.translate(centerPoint.x, centerPoint.y);
    stageCtx.rotate((Math.PI / 180) * rotate);
    stageCtx.globalAlpha = opacity;
    stageCtx.drawImage(
        layerImage,
        0,
        0,
        resultWidth,
        resultHeight,
        drawOffsetPoint.x,
        drawOffsetPoint.y,
        resultWidth,
        resultHeight,
    );

    return stageCanvas;
};
